import { __name, __publicField } from './chunk-2JTKI4GS.mjs';
import { Component } from 'react';
import { Route } from 'react-router-dom';
import { jsx } from 'react/jsx-runtime';

var _NotFound = class _NotFound extends Component {
  render() {
    return /* @__PURE__ */ jsx(
      Route,
      {
        render: ({ staticContext }) => {
          if (staticContext) staticContext.statusCode = 404;
          return _NotFound.data;
        }
      }
    );
  }
};
__name(_NotFound, "NotFound");
// just for test purpose
__publicField(_NotFound, "data", `The Page You Were Looking For Was Not Found`);
var NotFound = _NotFound;
var NotFoundComponent_default = NotFound;

export { NotFoundComponent_default as default };
//# sourceMappingURL=NotFoundComponent.mjs.map
//# sourceMappingURL=NotFoundComponent.mjs.map